import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useHistory } from "react-router-dom";
import { resetUserData, setUserData } from "../../../redux/member";
import { RootState } from "../../../redux/store";
import { EDIT_PROFILE, SELECT_MOOD, SETTINGS, MY_PROFILE, ONBORADING_SCREEN, SMS_VERIFICATION, VERIFY_PROFILE, HOMEPAGE } from '../../../navigation/Constants';
import account from '../../../services/accountService'
import { resetMoodData } from "../../../redux/mood";
import { resetSignupQuestions } from "../../../redux/signupQuestions";
import { reset } from "../../../redux/app";
import { resetSignupData } from "../../../redux/signup";
import { resetCarpet } from '../../../redux/carpet';
import usePrepareLink from "../../../hooks/usePrepareLink";
import { GET_PARAMS, GET_POPUPS } from "../../../const/router";
import NiceModal from "@ebay/nice-modal-react";
import { GAActions, GACategoryName, GAEventNames, GAUniqueEventIds, GenderType, HomeScreenType } from "../../../helpers/Enums";
import { deleteMemberMood, getProfileStatus } from "../../../services/memberService";
import { resetUserMood } from "../../../redux/member";
import { recordGaEvent } from "../../../helpers/GoogleAnalytics";


const MyProfile = () => {
    const member = useSelector((state: RootState) => state.member);
    const dispatch = useDispatch();
    let history = useHistory();


    const recordEvent = (element: React.MouseEvent<HTMLHeadingElement, MouseEvent>) => {
        let { target } = element;
        let anchorElement = target as HTMLAnchorElement;
        let label = anchorElement.textContent !== null ? anchorElement.textContent : "";
        recordGaEvent(GAEventNames.APP_ENGAGMENT, GACategoryName.PROFILE_ENGAGMENT, GAActions.CLICK, label, GAUniqueEventIds.APP_ENGAGMENT);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        updateProfileStatus();
    }, [])

    const updateProfileStatus = async () => {
        const { data } = await getProfileStatus();
        dispatch(setUserData(data));
    }


    //moodText

    const openSelectMood = () => {
        history.push({
            pathname: SELECT_MOOD,
            state: {
                returnUrl: MY_PROFILE,
                shouldGoBack: true
            },
        });
    };

    const advacnedSearchlink = usePrepareLink({
        pushToQuery: {
            [GET_PARAMS.popup]: GET_POPUPS.popup.advancedSearch,
        },
        keepOldQuery: true,
    });

    const premiumMessagelink = usePrepareLink({
        pushToQuery: {
            [GET_PARAMS.popup]: GET_POPUPS.popup.premiumMessage,
        },
        keepOldQuery: true,
    });

    const premiumPlanDetails = usePrepareLink({
        pushToQuery: {
            [GET_PARAMS.popup]: GET_POPUPS.popup.premiumPlanDetails,
        },
        keepOldQuery: true,
    });

    // const logout = () => {
    //    account.logout();
    //    clearReduxStoreDate();
    //    history.replace(ONBORADING_SCREEN);
    // };

    // const clearReduxStoreDate = () => {
    //    dispatch(resetUserData());
    //    dispatch(resetMoodData());
    //    dispatch(reset());
    //    dispatch(resetSignupQuestions());
    //    dispatch(resetSignupData());
    //    dispatch(resetCarpet());
    // };

    // const handlePremiumClick = () => {
    //     NiceModal.show("action_modal", {
    //         onNext: () => NiceModal.hide("action_modal"),
    //         headerTitle: "בקרוב בשושק'ה",
    //         contentTitle: "ממש בקרוב אפשר יהיה לשדרג לפרימיום. מבטיחים לעדכן",
    //         primaryButtonText: "אישור",
    //         showCloseButton: true,
    //         showSeconderyButton: false
    //     });
    // }



    const link = usePrepareLink({
        state: {
            navigateFromProfile: true,
            isMyProfile: true
        },
        query: {
            [GET_PARAMS.memberCode]: member.memberCode,
        },
        pushToQuery: {
            [GET_PARAMS.popup]: GET_POPUPS.popup.profile,
        },
        keepOldQuery: true,
    });


    return (
        <>
            {/*top nav*/}
            <div className="top_sec wf-section">
                <NavLink className="top_logo_bounakir w-inline-block" to={HOMEPAGE}>
                    <img src="assets/images/shoshke_logo.svg" loading="lazy" />
                </NavLink>
                <div className="top_content profile w-clearfix">
                    <h1 className="top_title messages">הפרופיל שלי</h1>
                </div>
            </div>
            {/*top nav end*/}
            <div className="my_prof_sec" style={{ paddingBottom: "6vh" }}>
                <div className="prof_pict_group">
                    <Link to={link} style={{ borderRadius: '50%' }}>
                        <div className="my_prof_pict">
                            {
                                member.profilePicture &&
                                <img
                                    src={member.profilePicture}
                                    loading="lazy"
                                    alt=""
                                    className="item_pict"
                                />
                            }

                        </div>
                    </Link>
                    <div className="prof_eye">
                        <Link to={link}>
                            <img src="/assets/images/ic_eye.svg" loading="lazy" alt="" />
                        </Link>
                    </div>
                    {/* <img
                  src="/assets/images/ic_premium.svg"
                  loading="lazy"
                  alt=""
                  className="prof_premium"
               /> */}
                </div>

                <div className="prof_title_group">
                    <div className="user_basic_info my_prof">
                        <h2 className="user_name my_prof">{`${member.nickName},`}</h2>
                        <div className="age_txt my_prof">{member.age}</div>
                        {
                            member?.profileIsVerified && member?.hasBeenAuthenticatedByPhone ? <div className="ic_vi my_prof" /> : null
                        }
                    </div>
                    {/* <div className="my_prof_flah">
                        <div>זוגיות</div>
                    </div> */}
                </div>


                {/* <a href="#" className="button_prof w-inline-block" onClick={openSelectMood} style={{ marginLeft: 'auto', marginRight: '15px' }}>
               <div>עדכון מצב רוח</div>
               <div className="button_prof_ic">
                  <img src="/assets/images/ic_edit.svg" loading="lazy" alt="" />
               </div>
            </a> */}

                <div className="prof_mood_group">

                    <div className="prof_mood_info">
                        {!member.moodImage &&
                            <h3 className="prof_mood_title">{member.genderId === GenderType.MALE ? "לאיזו פעילות תרצה להכיר שותפים?" : "לאיזו פעילות תרצי להכיר שותפים?"}</h3>}
                        {member.moodText && member.moodImage && <>
                            <h3 className="prof_mood_title">אשמח ל{member.moodText} </h3>
                            <div className="mood_info_txt red">
                                {member.profileSentence}
                            </div>
                        </>}
                        <a href="#" onClick={openSelectMood} className="prof_mood_link">{member.moodImage ? 'שינוי פעילות' : 'בחירת פעילות'}</a>

                    </div>
                    <ul role="list" className="prior_links_list my_prof w-list-unstyled">

                        <li className="prem_info_item">


                            {
                                member.isPremium ?
                                    <Link to={premiumPlanDetails} className="prior_link w-inline-block">
                                        <div className="prior_icon_block">
                                            <img src="assets/images/ic_premline_menu.svg" loading="lazy" alt="" />
                                        </div>
                                        <div className="prior_link_info w-clearfix" >
                                            <h4 className="prior_link_title" onClick={recordEvent}>מנוי פעיל</h4>
                                            {member.isPremium_Renewing ? <div>המנוי יתחדש בתאריך: {member.subscriptionExpiryDate}</div> : <div>המנוי יסתיים בתאריך: {member.subscriptionExpiryDate}</div>}
                                            <div className="prior_status_block black w-clearfix">
                                                {/* <div>בחר</div> */}
                                                <img
                                                    src="assets/images/prior_arrow.svg"
                                                    loading="lazy"
                                                    alt=""
                                                    className="prior_stat_icon"
                                                />
                                            </div>
                                        </div>
                                    </Link>

                                    :
                                    <Link to={premiumMessagelink} className="prior_link w-inline-block">
                                        <div className="prior_icon_block">
                                            <img src="assets/images/ic_menu_premium.svg" loading="lazy" alt="" />
                                        </div>
                                        <div className="prior_link_info w-clearfix" >
                                            <h4 className="prior_link_title" onClick={recordEvent}>{member.genderId === GenderType.MALE ? "הפוך" : "הפכי"} את המנוי לפרימיום</h4>
                                            <div>מנויי פרימיום נהנים מיותר אפשרויות</div>
                                            <div className="prior_status_block black w-clearfix">
                                                {/* <div>בחר</div> */}
                                                <img
                                                    src="assets/images/prior_arrow.svg"
                                                    loading="lazy"
                                                    alt=""
                                                    className="prior_stat_icon"
                                                />
                                            </div>
                                        </div>
                                    </Link>
                            }



                            <div className="prior_item_line" />
                        </li>

                        <li className="prem_info_item">
                            <Link to={EDIT_PROFILE} className="prior_link w-inline-block">
                                <div className="prior_icon_block">
                                    <img src="assets/images/ic_menu_editprof.svg" loading="lazy" alt="" />
                                </div>
                                <div className="prior_link_info w-clearfix">
                                    <h4 className="prior_link_title" onClick={recordEvent}>עריכת פרופיל</h4>
                                    <div>{member.genderId === GenderType.MALE ? "הצג" : "הציגי"} את עצמך לחברים בשושק'ה</div>
                                    <div className="prior_status_block black w-clearfix">
                                        {/* <div>ערוך</div> */}
                                        <img
                                            src="assets/images/prior_arrow.svg"
                                            loading="lazy"
                                            alt=""
                                            className="prior_stat_icon"
                                        />
                                    </div>
                                </div>
                            </Link>
                            <div className="prior_item_line" />
                        </li>
                        {member.profileIsVerified ? null :
                            <li className="prem_info_item">
                                {
                                    member.hasBeenAuthenticatedByPhone ?
                                        member.profileRequierdVerification ?
                                            <a href="#" className="prior_link w-inline-block">
                                                <div className="prior_icon_block">
                                                    <img src="assets/images/ic_menu_validprof.svg" loading="lazy" alt="" />
                                                </div>
                                                <div className="prior_link_info w-clearfix">
                                                    <h4 className="prior_link_title" onClick={recordEvent}>סטטוס אימות פרופיל:</h4>
                                                    <div>ממתין לאישור</div>
                                                    <div className="prior_status_block black w-clearfix">
                                                        {/* <div>ערוך</div> */}
                                                        <img
                                                            src="assets/images/prior_arrow.svg"
                                                            loading="lazy"
                                                            alt=""
                                                            className="prior_stat_icon"
                                                        />
                                                    </div>
                                                </div>
                                            </a>
                                            :
                                            <Link to={VERIFY_PROFILE} className="prior_link w-inline-block">
                                                <div className="prior_icon_block">
                                                    <img src="assets/images/ic_menu_validprof.svg" loading="lazy" alt="" />
                                                </div>
                                                <div className="prior_link_info w-clearfix">
                                                    <h4 className="prior_link_title" onClick={recordEvent}>אימות תמונה</h4>
                                                    <div>חברים עם תמונה מאומתת מקבלים יותר פניות</div>
                                                    <div className="prior_status_block black w-clearfix">
                                                        {/* <div>ערוך</div> */}
                                                        <img
                                                            src="assets/images/prior_arrow.svg"
                                                            loading="lazy"
                                                            alt=""
                                                            className="prior_stat_icon"
                                                        />
                                                    </div>
                                                </div>
                                            </Link>
                                        :
                                        <Link to={SMS_VERIFICATION} className="prior_link w-inline-block">
                                            <div className="prior_icon_block">
                                                <img src="assets/images/ic_menu_validprof.svg" loading="lazy" alt="" />
                                            </div>
                                            <div className="prior_link_info w-clearfix">
                                                <h4 className="prior_link_title" onClick={recordEvent}>אימות פרופיל</h4>
                                                <div>חברים עם פרופיל מאומת מקבלים יותר פניות</div>
                                                <div className="prior_status_block black w-clearfix">
                                                    {/* <div>ערוך</div> */}
                                                    <img
                                                        src="assets/images/prior_arrow.svg"
                                                        loading="lazy"
                                                        alt=""
                                                        className="prior_stat_icon"
                                                    />
                                                </div>
                                            </div>

                                        </Link>
                                }
                                <div className="prior_item_line" />
                            </li>
                        }


                        <li className="prem_info_item">
                            <Link to={advacnedSearchlink} className="prior_link w-inline-block">
                                <div className="prior_icon_block">
                                    <img src="assets/images/ic_menu_filter.svg" loading="lazy" alt="" />
                                </div>
                                <div className="prior_link_info w-clearfix">
                                    <h4 className="prior_link_title" onClick={recordEvent}> העדפות חיפוש </h4>
                                    <div>מה חשוב לך בהיכרות עם הצד השני?</div>
                                    <div className="prior_status_block black w-clearfix">
                                        {/* <div>ערוך</div> */}
                                        <img
                                            src="assets/images/prior_arrow.svg"
                                            loading="lazy"
                                            alt=""
                                            className="prior_stat_icon"
                                        />
                                    </div>
                                </div>
                            </Link>
                            <div className="prior_item_line" />
                        </li>
                        <li className="prem_info_item">
                            <Link to={SETTINGS} className="prior_link w-inline-block">
                                <div className="prior_icon_block">
                                    <img src="assets/images/ic_menu_setting.svg" loading="lazy" alt="" />
                                </div>
                                <div className="prior_link_info w-clearfix">

                                    <h4 className="prior_link_title" onClick={recordEvent}>הגדרות חשבון</h4>
                                    <div>ניהול החשבון שלך בשושק'ה</div>
                                    <div className="prior_status_block black w-clearfix">
                                        {/* <div>ערוך</div> */}
                                        <img
                                            src="assets/images/prior_arrow.svg"
                                            loading="lazy"
                                            alt=""
                                            className="prior_stat_icon"
                                        />
                                    </div>
                                </div>
                            </Link>
                            <div className="prior_item_line" />
                        </li>
                        <li className="prem_info_item">
                            <a href="#" className="prior_link w-inline-block">
                                <div className="prior_icon_block">
                                    <img src="assets/images/ic_menu_help.svg" loading="lazy" alt="" />
                                </div>
                                <div onClick={() => {
                                    window.open("https://www.motke.co.il/%D7%A2%D7%96%D7%A8%D7%94", '_blank', 'noopener,noreferrer');
                                }} className="prior_link_info w-clearfix">
                                    <h4 className="prior_link_title" onClick={recordEvent}>עזרה </h4>
                                    <div>הסברים וטיפים לשימוש</div>
                                    <div className="prior_status_block black w-clearfix">
                                        {/* <div>ערוך</div> */}
                                        <img
                                            src="assets/images/prior_arrow.svg"
                                            loading="lazy"
                                            alt=""
                                            className="prior_stat_icon"
                                        />
                                    </div>
                                </div>
                            </a>
                            <div className="prior_item_line" />
                        </li>
                    </ul>
                </div>






            </div>




        </>
    )
}

export default MyProfile;